import {Avatar, Button, Checkbox, Input, message, Modal, Popover, Skeleton, Switch, Tooltip} from 'antd'
import {course_getCourseClassesAvailForStudent_Api, medal_addMedalAward_Api,} from 'apis'
import {getId, getType} from 'apis/model/base'
import classNames from 'classnames'
import {showConfirm} from 'components/Feed/TimeLineFeed'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {Formik, FormikConsumer} from 'formik'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {FaFilter, FaUserGraduate} from 'react-icons/fa6'
import {IoChevronDown, IoCopyOutline} from 'react-icons/io5'
import {PiCertificate, PiGraduationCap} from 'react-icons/pi'
import {RiMapPinFill, RiSearchLine, RiSubscript} from 'react-icons/ri'
import {TbCertificate, TbCertificateOff} from 'react-icons/tb'
import {compose, mapProps, pure} from 'recompose'
import {AppEntities} from 'views/AppLocals/enums'
import {NullAsDefault, pagerControls} from 'views/Shared'
import {StudentActionTypes} from '..'
import {
    course_assignMultiStudentToCourse_Api,
    course_assignStudentToCourse_Api,
    course_editStudentFromCourse_Api,
    course_getCourseById_Api,
    course_getCourseStudents_Api,
    course_revokeCertificateFromStudent_Api,
    course_revokeStudentFromCourse_Api
} from '../../../../apis'
import DynamicFieldsUtilization from '../../../../components/DynamicFields/DynamicFieldUtilization'
import {createSelectValue, createValue} from '../../../../components/form/utils'
import HeaderGroupItem from '../../../../components/ItemLayout/HeaderGroupItem'
import {FullSideModalLayout} from '../../../../components/Modal/SideModalLayout'
import {createModalTitle} from '../../../../components/renderFunctions/createModalTitle'
import {renderIf, renderIfElse, renderSelf, shallowDiff} from '../../../Shared'
import EntityList from '../../EntityList'
import {showDeleteConfirmDialog} from '../../factory/createConfirmDialog'
import createContextMenu from '../../factory/createContextMenu'
import {notifyOnError} from '../../factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from '../../factory/createNotification'
import {bindQueryParam, bindQueryParams} from '../../functions/routerHelper'
import {HeaderWithIconLine} from '../../Templates/items/ListHeader'
import {CourseClassSelector} from '../components/CourseClassSelector'
import {StudentSelector} from '../components/StudentSelector'
import {createControlledFormField} from "../../factory/createFormField";
import LookupField from "../../../../components/LookupField";
import FieldDecorator from "../../../../components/form/FieldDecorator";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {MdChurch, MdOutlineArrowForward} from "react-icons/md";
import {StudentInformationFull} from "../Student/components/StudentInformationFull";
import CourseStudentSubjectResults from "./CourseStudentSubjectResults";
import getTitle from "../../../../helpers/getTitle";
import getAliasName from "../../../../helpers/getAliasName";
import copyToClipboard from "copy-to-clipboard";
import {BsInfoCircleFill} from "react-icons/bs";
import {renderMetadata} from "../../../../components/DynamicFields/functions/renderMetadata";
import {GiPlainCircle} from "react-icons/gi";
import Async from "../../../../modules/asyncCache/components/Async";
import WorkspaceContext from "../../../Workspace/WorkspaceContext";
import Pure from "../../../../components/Pure";
import {renderEmptyHolderMember} from "../../CatholicHousehold/functions/renderEmptyHolderMember";
import {bindingSearch} from "../../../Shared/components/PagerControls";
import withTranslate from "../../../../modules/local/withTranslate";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import LoadingBlock from "../../../Loading/LoadingBlock";
import {ItemInformation} from "../../../../components/common/ItemInformation";
import EmptyHolder from "../../../../components/EmptyHolder";

const StudentSelection = ({form, name, value, course, defaultValue = [], handleChange = NullAsDefault, ...props}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const students = value || defaultValue;
    const {organization} = useContext(WorkspaceContext)

    return (
        <div className="flex flex-col gap-3">
            <div className="flex">
                <LookupField
                    cacheRequired={false}
                    title={t('select student')}
                    createIfNotExists={false}
                    placeholder={t('click to select / create')}
                    apiPath={`/lookup/student/get-by-types?owner_type=organization&owner_id=${organization?.id}&not_course_id=${course?.id}`}
                    OptionWrapper={({children, ...props}) =>
                        <div className="flex items-center gap-2 relative list-item" {...props}>
                            {children}
                        </div>
                    }
                    renderOption={(o, i) => {
                        return (
                            <div key={i} className="p-2 flex items-center flex-1 gap-3">
                                {renderIf(
                                    !isSm,
                                    <Avatar
                                        size={50}
                                        src={o.avatar}
                                        className="flex flex-center background-200 rounded-lg"
                                        icon={<FaUserGraduate size={20} style={{color: '#dddddd'}}/>}
                                    />
                                )}
                                <div className="flex flex-col">
                                        <span className="font-bold text-sm text-color-000 leading-snug">
                                            {o?.patron_saint_name || o?.patron_saint?.name} {o?.fullname}
                                        </span>
                                    <ItemInformation label="student code" value={_.get(o, 'student_idcode')}
                                                     className="text-xs tracking-wider"/>
                                </div>
                            </div>
                        )
                    }}
                    handleChange={(e) => {
                        let _students = _.cloneDeep(students);

                        const student = _.find(_students, {id: e.target.id});
                        if (!student) {
                            _students.push({
                                student: e.target,
                                student_name: e.target.value,
                                student_id: e.target.id,
                                id: e.target.id || e.target.value,
                            });
                            handleChange(_students)
                        }
                    }}
                />
            </div>
            {students.map((std, idx) => {
                const {student, student_name} = std ?? {}
                return (
                    <div key={idx} className="p-2 background-50 rounded-lg custom-item-render relative">
                        {student ? (
                            <div className="flex items-center gap-2">
                                <Avatar
                                    size={36}
                                    src={student.avatar}
                                    icon={<FaUserGraduate size={16} className="text-color-500"/>}
                                    className="flex flex-center background-200"
                                />
                                <div className="flex flex-col flex-1">
                                    <span className="font-bold text-sm text-color-000 no-underline leading-snug">
                                        {student?.prefix_title || student?.patron_saint_name || ''} {getTitle(student)}
                                    </span>
                                    <span className="font-mono font-medium text-xs text-blue-500 tracking-wider">
                                        #{_.get(student, 'student_idcode')}
                                    </span>
                                </div>
                            </div>
                        ) : (
                            <div className="font-bold text-sm text-color-000">
                                {student_name}
                            </div>
                        )}
                        <BiTrash
                            onClick={() => {
                                let _students = _.cloneDeep(students);
                                showDeleteConfirmDialog({
                                    translate: t,
                                    title: 'delete student',
                                    message: 'are you sure you want to delete this student',
                                    onOk: () => {
                                        _.remove(_students, {id: student?.id});
                                        handleChange(_students)
                                    },
                                })
                            }}
                            className="absolute top-5 right-5 contextIcon text-primary-200 hover:text-primary cursor-pointer"
                        />
                    </div>
                )
            })}

        </div>
    )
}


const formSchema = {
    student: {
        title: 'student',
        children: [
            {
                name: 'student',
                component: mapProps(({name, value, form, onChange}) => {
                    const {owner_id, owner_type} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        owner_id,
                        owner_type,
                    }
                })(StudentSelector),
            },
        ],
    },
    course_class: {
        title: 'transfer to class',
        children: [
            {
                name: 'course_class',
                component: mapProps(({name, value, form, onChange}) => {
                    const {course_id, student_id} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        course_id,
                        customConfigs: {
                            apiInfo: course_getCourseClassesAvailForStudent_Api,
                            query: bindQueryParams([{student_id}, {id: course_id}]),
                        },
                    }
                })(CourseClassSelector),
            },
        ],
    },
    select_class_in_course: {
        title: 'choose classes',
        children: [
            {
                component: compose(withTranslate)(({translate}) => (
                    <div className="text-xs text-color-400 italic tracking-wide leading-snug">
                        {`* ${translate('one student can study multiple classes hint')}`}
                    </div>
                )),
            },
            {
                // course_class_ids (mảng) - 1 học viên có thể được xếp vào nhiều lớp của cùng
                // 1 khóa cùng lúc. BE (assignMultiStudentToCourse) nhận cả CSV/mảng và vẫn
                // chấp nhận "course_class_id" đơn cũ để tương thích ngược.
                name: 'course_class_ids',
                component: compose(
                    withTranslate,
                    mapProps(({name, translate, onChange, value, form, ...restForm}) => {

                        const options = form?.values?.course_classes?.map(e => {
                            return {value: e.id, label: `${e?.title} (${e?.student_count} ${translate('students')})`}
                        })
                        return {
                            name,
                            mode: 'multiple',
                            allowClear: true,
                            className: 'w-full',
                            value: value || undefined,
                            onChange: (value) => {
                                onChange(createSelectValue('course_class_ids', value))
                            },
                            placeholder: translate('choose classes'),
                            options: options,
                        }
                    }),
                    pure
                )(SelectWidget),
            },
        ],
    },
    notes: {
        title: 'notes',
        children: [
            {
                name: 'notes',
                component: createControlledFormField({
                    rows: 3,
                    className: 'w-full',
                    placeholder: 'notes',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    information_group_header: {
        children: [
            {
                component: () => <HeaderGroupItem title="manager information"/>,
            },
        ],
    },
    metadata: {
        children: [
            {
                name: 'metadata',
                component: ({name, value, onChange}) => (
                    <DynamicFieldsUtilization
                        name={name}
                        value={value}
                        className="w-full"
                        onChange={(value) => {
                            onChange(createValue(name, value ?? null))
                        }}
                    />
                ),
            },
        ],
    },
    diocese_location: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'belong to parish',
                name: 'parish',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('choose parish')}
                                    createIfNotExists={true}
                                    defaultValue={form?.values?.parish_name}
                                    selectedOption={form?.values?.parish}
                                    placeholder={t('click to select / create')}
                                    apiPath={`/lookup/parish/get-by-types`}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => {
                                        const {fullname, diocese_fullname, location_address} = o ?? {}
                                        return (
                                            <div key={i} className="flex items-center flex-1 gap-3">
                                                <Avatar
                                                    size={50}
                                                    src={o.avatar}
                                                    className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                    icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                />
                                                <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                    <div className="space-x-1 leading-snug">
                                                        <span
                                                            className="font-bold text-sm text-color-000">{fullname}</span>
                                                        <span
                                                            className="font-medium text-xs text-blue-500 italic leading-snug">{`( ${diocese_fullname} )`}</span>
                                                    </div>
                                                    {renderIf(
                                                        location_address,
                                                        <div className="flex items-center gap-x-1">
                                                            <RiMapPinFill size={11} className="text-color-400"/>
                                                            <span
                                                                className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">{location_address}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    }}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            parish: e.target,
                                            parish_name: e.target.value,
                                            parish_id: e.target.id,
                                            diocese: e.target.diocese,
                                            diocese_name: e.target?.diocese?.name,
                                            diocese_id: e.target?.diocese?.id
                                        });
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
            {
                label: 'diocese',
                name: 'diocese',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose diocese')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.diocese_name}
                                            selectedOption={form?.values?.diocese}
                                            apiPath={`/lookup/diocese/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        <Avatar
                                                            size={50}
                                                            src={o.avatar}
                                                            className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                            icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                        />
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                              <span className="font-bold text-sm text-color-000">
                                                                  {fullname}
                                                              </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                    {location_address}
                                                                  </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    diocese: e.target,
                                                    diocese_name: e.target?.value,
                                                    diocese_id: e.target?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
        ],
    },

    students_selection: {
        title: 'students',
        children: [
            {
                name: 'students',
                component: createControlledFormField({
                    className: 'w-full',
                    Component: StudentSelection,
                    withForm: ({...props}) => ({form: {...props}}),
                    withProps: ({name, value, onChange, ...props}) => ({
                        defaultValue: value,
                        handleChange: (_value) => {
                            onChange(createValue(name, _value))
                        },
                        ...props
                    }),
                    withValues: ({resetKey, course}) => ({
                        resetKey, course
                    }),
                }),
            },
        ],
    },

    payment_status: {
        title: 'payment status',
        children: [
            {
                name: 'payment_status',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate: t}) => ({
                        name,
                        checked: !!value,
                        // style: {width: 'auto'},
                        checkedChildren: t('yes'),
                        // unCheckedChildren: t('no'),
                        className: 'w-fit justify-end',
                        onChange: (value) => {
                            onChange(createValue(name, Number(value ?? 0)))
                        },
                    }))
                )(Switch),
            },
        ],
    },
}

export const CourseStudentAssignmentModal = ({
                                                 course = {},
                                                 owner_id,
                                                 owner_type,
                                                 onSubmit = NullAsDefault,
                                             }) => {
    const t = useTranslate();

    const initialValues = useMemo(
        () => ({
            owner_id,
            owner_type,
            students: [],
            course,
            course_class_ids: [],
            course_classes: course?.course_classes || []
        }),
        [owner_id, owner_type, course]
    )

    const validate = (values) => {
        let errors = {}

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {students, course_class_ids} = values ?? {}
                const ids = students.map(item => item.student_id);

                onSubmit({
                    student_ids: ids,
                    course_class_ids: course_class_ids || []
                })
            }}>
            <ActionModalWrapper action={<FormActionBar submitText="enroll"/>}>
                <div className="text-color-400 italic">
                    {`* ${t('assign student for course description')}`}
                </div>
                <FieldsFactory
                    formSchema={[
                        formSchema.students_selection,
                        formSchema.select_class_in_course,
                    ]}
                />
            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseStudentUpdateModal = ({
                                             item,
                                             course,
                                             courseStudent,
                                             onSubmit = NullAsDefault,
                                             source = null
                                         }) => {
    const t = useTranslate()
    const [current, setCurrent] = useState('overview');

    const initialValues = useMemo(() => ({
            notes: courseStudent?.notes ?? null,
            course: courseStudent?.course ?? {},
            metadata: courseStudent?.metadata ?? [],

            payment_status: courseStudent?.payment_status ?? null,

            // diocese_id: _.get(courseStudent, 'diocese.id', ''),
            // diocese_name: _.get(courseStudent, 'diocese.name', ''),
            // diocese: _.get(courseStudent, 'diocese', ''),
            //
            // parish_id: _.get(courseStudent, 'parish.id', ''),
            // parish_name: _.get(courseStudent, 'parish.name', ''),
            // parish: _.get(courseStudent, 'parish', ''),

            subject_ids: _.get(courseStudent, 'registered_subjects', []).map(e => {
                return e?.id;
            })
        }),
        []
    );

    const validate = (values) => {
        let errors = {}

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            // enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={({metadata, subject_ids, diocese, parish, ...values}) => {
                const changes = shallowDiff(values, initialValues)
                onSubmit(
                    _.omitBy(
                        {
                            ...(changes ?? {}),
                            metadata: JSON.stringify(metadata),
                            subject_ids: subject_ids ? subject_ids.join(",") : undefined
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                tab={current}
                action={<FormActionBar submitText="save"/>}
                onTabChange={(key) => {
                    setCurrent(key)
                }}
                tabs={[
                    {
                        key: 'overview',
                        label: 'overview',
                        component: () => (
                            <StudentInformationFull {...courseStudent}/>
                        )
                    },
                    {
                        key: 'additional_info',
                        label: 'manage course information',
                        component: () => (
                            <React.Fragment>
                                <div className="text-color-400 italic">
                                    {`* ${t('update student information in the class description')}`}
                                </div>
                                <Pure>
                                    <FieldsFactory
                                        formSchema={[
                                            // formSchema.diocese_location,
                                            formSchema.payment_status,
                                            formSchema.notes,
                                            formSchema.metadata,
                                        ]}
                                    />
                                </Pure>
                                <FormikConsumer>
                                    {({values, errors, handleChange}) => {

                                        return (
                                            <div className="mt-3 flex flex-col gap-2">
                                                <div className="flex flex-col">
                                                    <span className="font-bold text-base text-slate-700 tracking-wider">
                                                        {t('subjects')}
                                                    </span>
                                                    <div style={{height: 3}} className="my-1 w-20 rounded-full bg-gray-400"/>
                                                    <span className="text-xs text-color-400 italic tracking-wider">
                                                        {`* ${t('with subject')}`}
                                                    </span>
                                                </div>
                                                <FieldDecorator key="subject_ids" errors={errors["subject_ids"]}>
                                                    <Checkbox.Group
                                                        className="grid grid-cols-2 gap-2"
                                                        name="subject_ids"
                                                        options={_.get(course, 'subjects', []).map(e => {
                                                            return {
                                                                value: e?.subject?.id,
                                                                label: e?.subject?.title
                                                            }
                                                        })}
                                                        defaultValue={values.subject_ids}
                                                        onChange={e => {
                                                            handleChange(createValue('subject_ids', e))
                                                        }}
                                                    />
                                                </FieldDecorator>
                                            </div>
                                        )
                                    }}
                                </FormikConsumer>
                            </React.Fragment>
                        ),
                    },
                ]}>
            </ActionModalWrapper>
        </Formik>
    )

}

export const CourseStudentDetail = ({item}) => {
    const t = useTranslate()
    const {metadata = [], registered_subjects = []} = item ?? {}

    return (
        <div className="flex flex-col gap-6">
            <StudentInformationFull {...item}/>
            <div className="flex flex-col gap-2">
                <HeaderWithIconLine
                    renderTitle={() => (
                        <div className="flex items-center gap-2">
                            <RiSubscript size={14} className="text-color-500"/>
                            <span className="font-semibold text-sm text-color-300 uppercase tracking-wider">
                                {t('subjects registered')}
                            </span>
                        </div>
                    )}
                />
                {renderIfElse(
                    registered_subjects.length > 0,
                    <div className="ml-2 md:ml-3 grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-1">
                        {registered_subjects.map((e, i) => (
                            <span key={i} className="flex items-center gap-x-2">
                                <GiPlainCircle size={7} className="text-blue-200"/>
                                <span className="font-semibold text-blue-600 text-sm italic leading-snug">
                                    {getTitle(e)}
                                </span>
                            </span>
                        ))}
                    </div>,
                    renderEmptyHolderMember("no data is available now", "the student has not registered for the course")
                )}
            </div>
            {renderIf(
                metadata.length > 0,
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        renderTitle={() => (
                            <div className="flex items-center gap-2">
                                <BsInfoCircleFill size={14} className="text-color-500"/>
                                <span className="font-semibold text-sm text-color-300 uppercase tracking-wider">
                                    {t('additional information')}
                                </span>
                            </div>
                        )}
                    />
                    <div className="ml-2 md:ml-3">
                        {renderMetadata(metadata, false, 'text-xs')}
                    </div>
                </div>
            )}
            <div className="h-1"/>
        </div>
    )
}

// Width dạng PX cố định cho 2 cột "gọn" (subjects/classes - chỉ chứa 1 badge số lượng + chevron từ
// khi đổi sang TableCellExpandableList, không còn in thẳng chuỗi dài như trước nên không cần rộng
// nữa, bạn báo 2 cột này nên "nhỏ vừa nội dung"). Cột "student" KHÔNG khai width - để trống cho
// table-fixed tự chia phần CÒN LẠI cho nó (bạn báo "cột này auto width"), khác 2 cột kia luôn cố
// định. table-fixed + min-width trên <table> (StudentTableWrapper) vẫn giữ để tránh lặp lại bug cũ
// (container hẹp bóp méo cột thao tác cố định, xem STUDENT_TABLE_MIN_WIDTH) - hẹp hơn min-width thì
// cuộn ngang (overflow-x-auto có sẵn) thay vì bóp cột.
const STUDENT_TABLE_COLUMNS = [
    {key: 'student', label: 'student'},
    {key: 'subjects', label: 'subjects registered', width: 130},
    {key: 'classes', label: 'learn in the class', width: 110},
]

// Cột student không khai width nên không cộng được trực tiếp - gán 1 mức tối thiểu hợp lý riêng cho
// nó khi tính min-width chung. Cột đầu nhóm thao tác (trạng thái kết quả) rộng ra 90 -> 110 (bạn báo
// chữ "CHƯA ĐÁNH GIÁ" hơi chật) - 4 cột icon còn lại giữ nguyên 40.
const STUDENT_TABLE_STUDENT_COL_MIN_WIDTH = 180
const STUDENT_TABLE_MIN_WIDTH =
    STUDENT_TABLE_STUDENT_COL_MIN_WIDTH +
    STUDENT_TABLE_COLUMNS.reduce((sum, col) => sum + (col.width ?? 0), 0) +
    110 + 40 * 4

const StudentResultStatus = ({result_status}) => {
    const t = useTranslate()
    let label_status
    let color_status
    switch (result_status) {
        case 1:
            label_status = 'passed'
            color_status = 'text-green-600'
            break
        case 0:
            label_status = 'failed'
            color_status = 'text-red-600'
            break
        default:
            label_status = 'not assessed yet'
            color_status = 'text-color-400'
            break
    }

    return (
        <span className={classNames('w-fit text-2xs font-bold uppercase tracking-wide italic', color_status)}>
            {t(label_status)}
        </span>
    )
}

// Cell hiện danh sách (môn học đăng ký / lớp đang học) dạng gọn - CHỈ hiện SỐ LƯỢNG + nút mở rộng
// (Popover) thay vì in thẳng chuỗi join(', ') vào ô bảng như trước (bạn báo: học viên đăng ký
// nhiều môn/lớp làm dòng bảng cao vọt hoặc vỡ layout, mà không có dữ liệu thì bỏ trống trơ trọi
// khó nhìn). Badge số lượng + nút mở rộng giữ chiều cao dòng ỔN ĐỊNH trong MỌI trường hợp (0, vài,
// hay rất nhiều item) - click mới bung Popover xem đầy đủ, không hiện sẵn.
const TableCellExpandableList = ({items = [], countLabel, renderItem = getTitle, emptyLabel = 'not update'}) => {
    const t = useTranslate()

    if (!items.length) {
        return <span className="text-xs text-color-400 italic">{t(emptyLabel)}</span>
    }

    return (
        <Popover
            trigger="click"
            placement="bottomLeft"
            overlayClassName="max-w-xs"
            content={
                <div className="max-h-60 overflow-y-auto flex flex-col gap-1.5">
                    {items.map((item, i) => (
                        <div key={i} className="text-sm text-color-100 leading-snug">
                            {renderItem(item)}
                        </div>
                    ))}
                </div>
            }>
            <button
                type="button"
                className="px-2 py-1 flex items-center gap-1 rounded-lg bg-primary-50 hover:bg-primary-100 text-primary-700 text-xs font-semibold whitespace-no-wrap transition-colors">
                {t(countLabel, {n: items.length})}
                <IoChevronDown size={11}/>
            </button>
        </Popover>
    )
}

const StudentTableRow = ({item, index, renderContextMenu, onRowClick, onUpdateClick, onScoreClick}) => {
    const t = useTranslate()
    const {student, result_status, registered_subjects = [], registered_classes = []} = item ?? {}
    const {avatar, fullname, patron_saint_name, student_idcode, user} = student ?? {}

    return (
        <tr
            className={classNames(
                'border-b border-color-50 hover:bg-blue-50 transition-colors',
                index % 2 !== 0 && 'bg-gray-50'
            )}>
            <td className="px-3 py-2">
                <div className="flex items-center gap-2">
                    <Avatar
                        size={32}
                        src={avatar || user?.avatar}
                        icon={<FaUserGraduate size={14} className="text-color-500"/>}
                        className="flex flex-center background-200 flex-shrink-0"
                    />
                    <div className="flex flex-col flex-1 min-w-0">
                        <span className="font-bold text-sm text-color-000 hover:text-primary leading-snug whitespace-no-wrap">
                            {renderIf(
                                patron_saint_name,
                                <span className="mr-1 font-semibold text-slate-500">
                                    {getAliasName(student, 'patron_saint')}
                                </span>
                            )}
                            {fullname}
                        </span>
                        {renderIf(
                            student_idcode,
                            <span
                                onClick={() => {
                                    copyToClipboard(student_idcode)
                                    message.info(t('copied'))
                                }}
                                className="w-fit flex items-center font-mono text-xs text-blue-500 hover:text-blue-700 cursor-pointer">
                                #{student_idcode}
                                <IoCopyOutline size={12} className="ml-1"/>
                            </span>
                        )}
                    </div>
                </div>
            </td>
            <td className="px-3 py-2">
                <TableCellExpandableList
                    items={registered_subjects}
                    countLabel="registered subjects count"
                />
            </td>
            <td className="px-3 py-2">
                <TableCellExpandableList
                    items={registered_classes}
                    countLabel="registered classes count"
                />
            </td>
            {/* Trạng thái kết quả gộp về nhóm Thao tác (trước đây nhét dưới tên học viên, đẩy card
                tên/mã học viên bị chật/xuống dòng xấu ở màn hẹp - bạn báo) - đứng đầu nhóm 5 cột thao
                tác, cùng colSpan={5} ở header (StudentTableWrapper). */}
            <td className="p-2 text-center whitespace-no-wrap">
                <StudentResultStatus result_status={result_status}/>
            </td>
            <td className="p-2 text-center whitespace-no-wrap">
                <Tooltip title={t('view detail')}>
                    <button
                        className="p-1 flex flex-center rounded-lg hover:bg-secondary-100 text-secondary-500 hover:text-secondary-600 transition-colors"
                        onClick={() => onRowClick(item)}>
                        <MdOutlineArrowForward size={16}/>
                    </button>
                </Tooltip>
            </td>
            <td className="p-2 text-center whitespace-no-wrap">
                <Tooltip title={t('update info in course')}>
                    <button
                        className="p-1 flex flex-center rounded-lg hover:bg-blue-200 text-blue-500 hover:text-blue-700 transition-colors"
                        onClick={() => onUpdateClick(item)}>
                        <BiSolidEdit size={16}/>
                    </button>
                </Tooltip>
            </td>
            <td className="p-2 text-center whitespace-no-wrap">
                <Tooltip title={t('academic results')}>
                    <button
                        className="p-1 flex flex-center rounded-lg hover:bg-green-100 text-green-500 hover:text-green-600 transition-colors"
                        onClick={() => onScoreClick(item)}>
                        <PiGraduationCap size={16}/>
                    </button>
                </Tooltip>
            </td>
            <td className="p-2 text-center">
                {renderContextMenu(item)}
            </td>
        </tr>
    )
}

const StudentTableLoadingRows = () => (
    <>
        {[...Array(4)].map((_, i) => (
            <tr key={i} className="border-b border-color-50">
                <td className="px-3 py-3">
                    <div className="flex items-center gap-2">
                        <Skeleton.Avatar active size={32} shape="circle"/>
                        <Skeleton.Input active size="small" style={{width: '100%', height: 20}}/>
                    </div>
                </td>
                <td className="px-3 py-3">
                    <Skeleton.Input active size="small" style={{width: '100%', height: 20}}/>
                </td>
                <td className="px-3 py-3">
                    <Skeleton.Input active size="small" style={{width: '100%', height: 20}}/>
                </td>
                {[...Array(5)].map((_, j) => (
                    <td key={j} className="px-1 py-3 text-center">
                        <Skeleton.Input active size="small" style={{width: 20, height: 20}}/>
                    </td>
                ))}
            </tr>
        ))}
    </>
)

const StudentTableWrapper = ({children}) => {
    const t = useTranslate()

    return (
        // overflow-x-auto + table-fixed + min-width cố định (STUDENT_TABLE_MIN_WIDTH):
        //   - table-fixed: trước đây table-layout mặc định (auto) khiến 4 cột thao tác (chỉ khai
        //     width: 40 qua <col>) bị trình duyệt chia lại theo % còn thừa của w-full, kéo cả cụm
        //     THAO TÁC rộng bất thường dù icon chỉ chiếm 1 góc nhỏ (bạn báo lần 1).
        //   - min-width: sau khi ép table-fixed, đổi 3 cột đầu qua % lại co bóp khó lường khi
        //     container hẹp lại (sidebar Workspace chiếm chỗ) - cụm THAO TÁC cố định ~250px chiếm tỉ
        //     trọng lớn hơn hẳn, ép mã học viên/tên lớp xuống dòng vỡ layout (bạn báo lần 2). Đặt
        //     min-width = tổng width PX cố định của mọi cột - container hẹp hơn thì cuộn ngang
        //     (overflow-x-auto có sẵn) thay vì bóp cột dưới ngưỡng đọc được.
        <div className="overflow-x-auto">
            <table className="w-full table-fixed" style={{minWidth: STUDENT_TABLE_MIN_WIDTH}}>
                <colgroup>
                    {STUDENT_TABLE_COLUMNS.map(col => (
                        <col key={col.key} style={col.width ? {width: col.width} : {}}/>
                    ))}
                    <col style={{width: 110}}/>
                    <col style={{width: 40}}/>
                    <col style={{width: 40}}/>
                    <col style={{width: 40}}/>
                    <col style={{width: 40}}/>
                </colgroup>
                <thead>
                    <tr className="background-100 border-b border-color-100">
                        {STUDENT_TABLE_COLUMNS.map(col => (
                            <th
                                key={col.key}
                                // 2 cột hẹp (subjects/classes, width cố định 110-130) - tiêu đề dài
                                // ("MÔN HỌC ĐÃ ĐĂNG KÝ"...) tràn lố ra ngoài <th> đè lên cột kế bên
                                // khi ép whitespace-no-wrap trên nền table-fixed (bạn báo lỗi này) -
                                // cho phép xuống dòng (leading-snug) CHỈ ở 2 cột này. Cột "student"
                                // (auto width) vẫn giữ 1 dòng như cũ.
                                className={classNames(
                                    "px-3 py-2 text-left text-xs font-semibold text-color-300 uppercase tracking-wider",
                                    col.width ? "leading-snug" : "whitespace-no-wrap"
                                )}>
                                {t(col.label)}
                            </th>
                        ))}
                        <th
                            colSpan={5}
                            className="px-3 py-2 text-center text-xs font-semibold text-color-300 uppercase tracking-wider">
                            {t('actions')}
                        </th>
                    </tr>
                </thead>
                <tbody className="background divide-y divide-color-50">
                    {children}
                </tbody>
            </table>
        </div>
    )
}

export const CourseStudents = ({
                                   item,
                                   header = null,
                                   controls = pagerControls,
                                   renderFooter = renderSelf,
                                   container_type = AppEntities.COURSE,
                               }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const course = item

    const [refreshToken, setRefreshToken] = useState()

    const {owner, subjects = []} = item ?? {}

    const [owner_id, owner_type] = [getId(owner), getType(owner)]

    // Live search debounce theo keyword — danh sách học viên có thể lên tới hàng trăm dòng
    // theo khóa học, không lọc phía client được, nên debounce trước khi gọi API thay vì lọc mỗi
    // keystroke. Input vẫn để defaultValue (KHÔNG value=) để ô gõ mượt, không bị giật lại khi state
    // debounce chưa kịp cập nhật.
    const [keyword, setKeyword] = useState(controls?.search?.keyword)
    const onSearch = _.debounce((value) => setKeyword(value), 500)
    const [course_class_id, setCourseClassId] = useState()
    const [filteredSubject, setFilteredSubject] = useState(null)
    // Panel filter theo môn học - đổi từ <Select> "Xem theo môn học" rời rạc sang ĐÚNG pattern filter
    // dùng chung toàn hệ thống (nút phễu + panel mở rộng in-flow, xem CourseClassStudentTab.js -
    // cùng khái niệm "lọc học viên theo môn" ở tab lớp học, giờ đồng bộ luôn cho tab khóa học, tránh 2
    // kiểu UI khác nhau cho cùng 1 việc). Môn học hiện dạng chip tag chọn 1 (bấm lại để bỏ chọn) thay
    // vì dropdown thả xuống.
    const [showMore, setShowMore] = useState(false)
    const hasAdvancedFilters = !!filteredSubject

    const apiInfo = course_getCourseStudents_Api

    const refreshKey = useMemo(
        () =>
            [
                apiInfo?.path.replace(':id', course?.id),
                JSON.stringify(keyword),
                course_class_id,
                refreshToken,
                filteredSubject?.id
            ].join(','),
        [keyword, refreshToken, course_class_id, filteredSubject]
    )

    const onError = notifyOnError(t)

    const onCancel = () => {
        setAction({})
    }

    const reload = () => {
        setRefreshToken(Date.now())
        onCancel()
    }

    const {handleAsyncAction: onAssign} = useAsyncAction({
        apiInfo: course_assignStudentToCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onAssignMulti} = useAsyncAction({
        apiInfo: course_assignMultiStudentToCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: course_editStudentFromCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const {handleAsyncAction: onRevoke} = useAsyncAction({
        apiInfo: course_revokeStudentFromCourse_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const {handleAsyncAction: onAwardMedal} = useAsyncAction({
        apiInfo: medal_addMedalAward_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })
    const {handleAsyncAction: onRevokeMedal} = useAsyncAction({
        apiInfo: course_revokeCertificateFromStudent_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.INFORMATION, t)
            reload()
        },
    })

    const handleAction = (action, params) => {
        const id = params?.id
        switch (action) {
            case StudentActionTypes.STUDENT_DETAIL:
            case StudentActionTypes.STUDENT_ASSIGN:
            case StudentActionTypes.STUDENT_IN_COURSE_UPDATE:
            case StudentActionTypes.STUDENT_SUBJECT_SCORE_SUMMARY:
                setAction({type: action, value: params})
                break
            case StudentActionTypes.STUDENT_REVOKE:
                if (id) {
                    showDeleteConfirmDialog({
                        translate: t,
                        title: 'revoke student',
                        message: 'are you sure you want to revoke this student',
                        onOk: () => {
                            onRevoke({}, {id})
                        },
                    })
                }
                break
            case StudentActionTypes.STUDENT_AWARDING_MEDAL:
                if (id) {
                    const {student} = params ?? {}
                    const ref_id = getId(course)
                    const ref_type = getType(course)
                    showConfirm({
                        icon: (
                            <TbCertificate
                                style={{color: '#48bb78'}}
                                className="anticon"
                            />
                        ),
                        className: 'custom-modal',
                        title: (
                            <span className="font-bold text-green-600">
                {t('award certificate')}
              </span>
                        ),
                        content: (
                            <span className="text-sm text-color-500 italic">
                {t(
                    'are you sure you want to award certification to this student'
                )}
              </span>
                        ),
                        okText: t('sure'),
                        cancelText: t('ignore'),
                        okButtonProps: {
                            type: 'primary',
                            className: 'button-rounded-lg no-border',
                        },
                        cancelButtonProps: {
                            className: 'button-rounded-lg no-border',
                        },
                        onOk: () => {
                            onAwardMedal(
                                {
                                    ref_id,
                                    ref_type,
                                },
                                {
                                    id: getId(student),
                                    prop: getType(student),
                                    medal_id: getId(course?.medal),
                                }
                            )
                        },
                    })
                }
                break

            case StudentActionTypes.STUDENT_REVOKE_MEDAL:
                if (id) {
                    const {student} = params ?? {}
                    const ref_id = getId(course)
                    const ref_type = getType(course)
                    showConfirm({
                        icon: (
                            <TbCertificateOff
                                style={{color: '#48bb78'}}
                                className="anticon"
                            />
                        ),
                        className: 'custom-modal',
                        title: (
                            <span className="font-bold text-green-600">
                {t('revoke certificate')}
              </span>
                        ),
                        content: (
                            <span className="text-sm text-color-500 italic">
                {t(
                    'are you sure'
                )}
              </span>
                        ),
                        okText: t('sure'),
                        cancelText: t('ignore'),
                        okButtonProps: {
                            type: 'primary',
                            className: 'button-rounded-lg no-border',
                        },
                        cancelButtonProps: {
                            className: 'button-rounded-lg no-border',
                        },
                        onOk: () => {
                            onRevokeMedal(
                                {},
                                {
                                    id: course?.id,
                                    student_id: getId(student)
                                }
                            )
                        },
                    })
                }
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <PiCertificate size={14} className="text-green-500"/>,
                        label: 'certification',
                        children: [
                            {
                                icon: <TbCertificate size={14} className="text-green-600"/>,
                                label: 'award certificate',
                                disabled: !!item?.medal_awards?.length || !course?.medal,
                                key: StudentActionTypes.STUDENT_AWARDING_MEDAL,
                            },
                            {
                                icon: <TbCertificateOff size={14} className="text-red-600"/>,
                                label: 'revoke certificate',
                                disabled: !!!item?.medal_awards?.length,
                                key: StudentActionTypes.STUDENT_REVOKE_MEDAL,
                            },
                        ],
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: StudentActionTypes.STUDENT_REVOKE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        [course]
    )

    const modal = useMemo(() => {
        let title
        let Content = NullAsDefault
        let params = {title: undefined}
        let modal_params = {}
        let Wrapper = ({children}) => children({item: {}})

        switch (action?.type) {
            case StudentActionTypes.STUDENT_SUBJECT_SCORE_SUMMARY:
                if (container_type === AppEntities.COURSE) {
                    title = (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('academic results')}
                        </div>
                    )
                    params = {
                        onCancel,
                        course: item,
                        student: action?.value?.student,
                        course_student: action?.value,
                    }
                    modal_params = {
                        width: 640,
                    }
                    Content = CourseStudentSubjectResults
                    break
                } else {
                    return (
                        <FullSideModalLayout
                            right={true}
                            onCancel={onCancel}
                            title={createModalTitle('academic results')}>
                            <CourseStudentSubjectResults
                                course={item}
                                student={action?.value?.student}
                                course_student={action?.value}
                            />
                        </FullSideModalLayout>
                    )
                }
            case StudentActionTypes.STUDENT_IN_COURSE_UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('update info in course')}
                    </div>
                )
                params = {
                    item: action?.value,
                    courseStudent: action?.value,
                    source: 'CourseStudentForm',
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {
                            id: action?.value?.id,
                        })
                    },
                }
                modal_params = {
                    width: 768,
                }
                Content = ({...rest}) => (
                    <Async{...{apiInfo: course_getCourseById_Api, query: {':id': course?.id}}}>
                        {(data) => {
                            const dataItem = _.get(data, 'response.data', course)

                            return (
                                <CourseStudentUpdateModal course={dataItem} {...rest} />
                            )
                        }}
                    </Async>
                )
                break
            case StudentActionTypes.STUDENT_ASSIGN:
                title = (
                    <div className="uppercase text-center font-bold text-color-000">
                        {t('assign course student')}
                    </div>
                )
                params = {
                    course,
                    onCancel,
                    onSubmit: (values) => {
                        const {...rest} = values ?? {}
                        onAssignMulti(
                            {...rest},
                            {
                                course_id: course?.id,
                            }
                        )
                    },
                }
                modal_params = {
                    width: 640,
                }
                Content = ({...rest}) => (
                    <Async
                        {...{
                            apiInfo: course_getCourseById_Api,
                            query: {':id': course?.id}
                        }}>
                        {
                            (data) => {
                                const dataItem = _.get(data, 'response.data', course)
                                return (
                                    <CourseStudentAssignmentModal
                                        {...rest}
                                        course={dataItem}
                                    />
                                )
                            }
                        }
                    </Async>
                )
                break
            case StudentActionTypes.STUDENT_DETAIL:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide  111-111-111">
                        {t('student information')}
                    </div>
                )
                params = {
                    item: action?.value
                }
                modal_params = {
                    width: 640,
                }
                Content = CourseStudentDetail
                break
            default:
                break
        }

        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock    />
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type, course_class_id])

    return (
        <ActionModalWrapper className="flex-1">
            {header}
            <div className="flex flex-col gap-4 flex-1">
                <div className="flex justify-end">
                    <Button
                        color="primary" variant="solid"
                        onClick={() => {
                            handleAction(StudentActionTypes.STUDENT_ASSIGN)
                        }}
                        className="flex flex-center rounded-lg no-border font-medium leading-tight px-2 md:px-3">
                        {t(isSm ? 'add student' : 'add student to course')}
                    </Button>
                </div>
                <div className="flex items-center gap-2">
                    <Input
                        name="keyword"
                        allowClear={true}
                        autoComplete="off"
                        defaultValue={keyword}
                        placeholder={t('type to search')}
                        prefix={<RiSearchLine size={14} className="text-color-400"/>}
                        size="large"
                        className="flex-1 rounded-lg"
                        onChange={(event) => {
                            onSearch(event?.target?.value)
                        }}
                    />
                    {subjects.length > 0 && (
                        <button
                            type="button"
                            onClick={() => setShowMore((v) => !v)}
                            style={{width: 40, height: 40, borderRadius: '0.5rem', cursor: 'pointer', position: 'relative'}}
                            className={classNames(
                                "flex flex-center transition-all border duration-300",
                                (showMore || hasAdvancedFilters) ?
                                    'bg-blue-600 border-blue-600 text-white' :
                                    'hover:scale-96 background hover:bg-blue-100 border-blue-300 hover:border-blue-500 text-blue-400 hover:text-blue-500'
                            )}>
                            <FaFilter size={16} className="transition-transform duration-200"/>
                            {hasAdvancedFilters && (
                                <span style={{top: -3, right: -3}} className="w-3 h-3 rounded-full bg-primary border-2 border-white absolute"/>
                            )}
                        </button>
                    )}
                </div>
                {showMore && subjects.length > 0 && (
                    <div style={{'--filter-advance-border': '#3182ce'}} className="p-3 flex flex-col gap-4 shadow-md mass-time-filter-advance">
                        <div className="flex flex-col gap-1.5">
                            <span className="font-medium text-2xs text-slate-400 uppercase tracking-wider">
                                {t('subjects')}
                            </span>
                            <div className="flex flex-wrap gap-1.5">
                                {subjects.map((e, i) => {
                                    const subj = e?.subject || e
                                    const id = getId(subj)
                                    const isSelected = filteredSubject?.id === id
                                    return (
                                        <span
                                            key={i}
                                            className={classNames(
                                                "px-3 py-1 text-xs font-medium rounded-lg border transition-colors cursor-pointer select-none",
                                                isSelected
                                                    ? "bg-indigo-600 border-indigo-600 text-white"
                                                    : "background border-color-200 text-color-300 hover:border-indigo-400 hover:text-indigo-500"
                                            )}
                                            onClick={() => setFilteredSubject(isSelected ? null : subj)}>
                                            {getTitle(subj)}
                                        </span>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                )}
                <EntityList
                    cacheId={refreshKey}
                    key={refreshKey}
                    apiInfo={apiInfo}
                    values={{keyword, course_class_id, subject_id: filteredSubject?.id, sort_by: 'name asc'}}
                    RenderEntity={React.Fragment}
                    PaginationMeta={NullAsDefault}
                    query={bindQueryParam({id: course?.id})}
                    renderItem={(item, index) => (
                        <StudentTableRow
                            key={index}
                            item={item}
                            index={index}
                            renderContextMenu={renderContextMenu}
                            onRowClick={(i) => handleAction(StudentActionTypes.STUDENT_DETAIL, i)}
                            onUpdateClick={(i) => handleAction(StudentActionTypes.STUDENT_IN_COURSE_UPDATE, i)}
                            onScoreClick={(i) => handleAction(StudentActionTypes.STUDENT_SUBJECT_SCORE_SUMMARY, i)}
                        />
                    )}
                    renderWrap={(children) => <StudentTableWrapper>{children}</StudentTableWrapper>}
                    renderLoading={() => <StudentTableLoadingRows/>}
                    renderEmpty={() => (
                        <tr>
                            <td colSpan="8">
                                <EmptyHolder />
                            </td>
                        </tr>
                    )}
                />
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}

export const CourseStudentsSearchBinding = (props) => bindingSearch(props)(CourseStudents)



